(() => {
  if (customElements.get('vk-tour-search')) return;
  customElements.define('vk-tour-search', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const triggers = [...document.querySelectorAll('[data-vk-search-trigger]')];
      let trigger;
      const dialog = this.querySelector('dialog');
      const input = this.querySelector('input[type="search"]');
      const suggestions = this.querySelector('.vk-tour-search__suggestions');
      const status = this.querySelector('[role="status"]');
      const all = this.querySelector('.vk-tour-search__all');
      const initial = suggestions.innerHTML;
      let timer;
      let revision = 0;
      const cancel = () => {
        clearTimeout(timer);
        revision++;
        suggestions.removeAttribute('aria-busy');
      };
      const open = (event) => {
        const opener = event.target.closest('[data-vk-search-trigger]');
        if (!opener) return;
        if (typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        trigger = opener;
        selectTab(tabs[0]);
        if (!dialog.open) dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
        input.focus();
        if (input.value.trim()) input.dispatchEvent(new Event('input'));
      };
      document.addEventListener('click', open);
      this.querySelector('.vk-tour-search__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => {
        cancel();
        triggers.forEach(item => item.setAttribute('aria-expanded', 'false'));
        status.textContent = '';
        const returnTo = trigger?.getClientRects().length ? trigger : triggers.find(item => item.getClientRects().length);
        returnTo?.focus({ preventScroll: true });
      });
      input.addEventListener('input', () => {
        cancel();
        const query = input.value.trim();
        const current = revision;
        status.textContent = '';
        suggestions.innerHTML = query ? '' : initial;
        all.hidden = !query;
        all.href = window.VkTourCatalog.url(query).href;
        if (!query) return;
        status.textContent = this.dataset.loading;
        suggestions.setAttribute('aria-busy', 'true');
        timer = setTimeout(async () => {
          try {
            const tours = window.VkTourCatalog.search(await window.VkTourCatalog.load(), query);
            if (current !== revision || !dialog.open) return;
            window.VkTourCatalog.render(suggestions, this.querySelector('[data-vk-result-template]'), tours.slice(0, 6), this.dataset.empty);
            status.textContent = this.dataset.updated;
          } catch (error) {
            if (error.name !== 'AbortError' && current === revision) status.textContent = this.dataset.error;
          } finally {
            if (current === revision) suggestions.removeAttribute('aria-busy');
          }
        }, 250);
      });
      this.querySelector('form').addEventListener('submit', event => {
        event.preventDefault();
        dialog.close();
        window.location.assign(window.VkTourCatalog.url(input.value));
      });
      // Counts are optional preferences only; they never change prices or availability.
      this.querySelectorAll('[data-vk-counter]').forEach(counter => {
        const count = counter.querySelector('input');
        const buttons = [...counter.querySelectorAll('[data-vk-count-step]')];
        const sync = () => {
          const value = Math.min(99, Math.max(0, Math.floor(Number(count.value) || 0)));
          count.value = String(value);
          buttons[0].disabled = value === 0;
          buttons[1].disabled = value === 99;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          count.value = String((Number(count.value) || 0) + Number(button.dataset.vkCountStep));
          sync();
        }));
        count.addEventListener('input', sync);
        count.addEventListener('change', sync);
        sync();
      });
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const selectTab = (selected) => {
        if (this.dataset.aiEnabled !== 'true') selected = tabs[0];
        tabs.forEach(tab => {
          const active = tab === selected;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.querySelector('#' + tab.getAttribute('aria-controls')).hidden = !active;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index + tabs.length - 1) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          event.preventDefault();
          selectTab(next);
          next.focus();
        });
      });
      dialog.addEventListener('close', () => selectTab(tabs[0]));
      const header = document.querySelector('#header-component');
      const columns = header?.querySelector('.header__columns');
      const fitSearch = () => {
        if (!header || !columns) return;
        header.removeAttribute('data-vk-search-compact');
        if (matchMedia('(max-width: 749px)').matches) return;
        const right = columns.querySelector('.header__column--right');
        const center = columns.querySelector('.header__column--center');
        if (right && (right.scrollWidth > right.clientWidth + 1 ||
          (center && right.getBoundingClientRect().left < center.getBoundingClientRect().right + 8))) {
          header.setAttribute('data-vk-search-compact', '');
        }
      };
      const observer = new ResizeObserver(fitSearch);
      if (columns) {
        observer.observe(columns);
        const actions = columns.querySelector('header-actions');
        if (actions) observer.observe(actions);
        columns.querySelectorAll('.header-logo img').forEach(img => observer.observe(img));
      }
      document.fonts?.ready.then(() => { if (this.isConnected) fitSearch(); });
      this.cleanup = () => {
        cancel();
        observer.disconnect();
        document.removeEventListener('click', open);
      };
    }
    disconnectedCallback() { this.cleanup?.(); this.initialized = false; }
  });
})();
